import configs from '../../configs';

export const MAX_FILE_SIZE = configs.maxFileSize; // in Mb
export const FILE_INPUT_ACCEPT = 'image/*, .pdf, .doc, .docx';

export const BIOMARKERS_DOCUMENT_SOURCE = 'biomarkers';
